import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const fomsourceApi = api
  .enhanceEndpoints({ addTagTypes: ['FOMSource'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOMSources: builder.query<fo_msource[], string>({
        query: cid => `fomsource/${cid}`,
        providesTags: ['FOMSource']
      }),
      getFOMSourceById: builder.query<fo_msource, string>({
        query: id => `fomsource/byid/${id}`,
        providesTags: ['FOMSource']
      }),
      insertFOMSource: builder.mutation({
        query: fomsource => ({
          url: `fomsource/`,
          method: 'POST',
          body: fomsource
        }),
        invalidatesTags: ['FOMSource']
      }),
      updateFOMSource: builder.mutation({
        query: fomsource => ({
          url: `fomsource/`,
          method: 'PUT',
          body: fomsource
        }),
        invalidatesTags: ['FOMSource']
      }),
      deleteFOMSource: builder.mutation({
        query: fomsource => ({
          url: `fomsource/${fomsource.sr_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FOMSource']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOMSourcesQuery,
  useGetFOMSourceByIdQuery,
  useInsertFOMSourceMutation,
  useUpdateFOMSourceMutation,
  useDeleteFOMSourceMutation
} = fomsourceApi;

